import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck, FolderOpen, BookOpen, CheckCircle } from 'lucide-react';

const AboutServices = () => {
  const services = [
    {
      id: 1,
      icon: FileCheck,
      title: "Documentation Review & Preparation",
      description: "We assist in reviewing documents for completeness, consistency, and clarity, helping ensure they are ready for use or submission."
    },
    {
      id: 2,
      icon: FolderOpen,
      title: "Administrative & Record Management Support",
      description: "We help organize, manage, and maintain documentation in a structured way, reducing the burden of ongoing administrative tasks."
    },
    {
      id: 3,
      icon: BookOpen,
      title: "Guided Documentation Support",
      description: "Our team provides practical guidance to help clients understand documentation requirements and prepare accurate, well-structured records."
    },
    {
      id: 4,
      icon: CheckCircle,
      title: "Supporting Verification Services",
      description: "When appropriate, we offer human-led checks to help confirm information and improve confidence in submitted documentation. These services are designed to support—not replace—proper documentation practices."
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack mb-4">
            What We Do
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            We support our clients through a range of documentation-focused services, including:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <motion.div
                key={service.id}
                className="text-left"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="flex items-start mb-6">
                  <div className="w-16 h-16 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutServices;
